export default {
  PERMISSIONS_STATUS_STATE_MANAGER: Symbol.for('PERMISSIONS_STATUS_STATE_MANAGER'),
  PERMISSIONS_STATUS_SUBSCRIPTION: Symbol.for('PERMISSIONS_STATUS_SUBSCRIPTION'),
  GET_PERMISSIONS_STATUS_SERVICE: Symbol.for('GET_PERMISSIONS_STATUS_SERVICE'),
};
